export const nameMap = {
  greenskins: {
    name_de: "Glitzakram",
    name_en: "Shiny Stuff",
    name_cn: "闪亮小玩意",
    name_fr: "Lé Trucs Ki Brill’",
  },
  "the-empire": {
    name_de: "Magische Erbstücke",
    name_en: "Heirlooms of Magic",
    name_cn: "魔法秘宝",
    name_fr: "Reliques Ensorcelées",
  },
  heirlooms: {
    name_de: "Erbstücke",
    name_en: "Ancestral Heirlooms",
    name_cn: "传世秘宝",
    name_fr: "Héritages Ancestraux",
  },
  dwarfs: {
    name_de: "Zwergenrunen",
    name_en: "Runic Items",
    name_cn: "符文道具",
    name_fr: "Objets Runiques",
  },
  general: {
    name_de: "Gewöhnliche Magische Gegenstände",
    name_en: "Common Magic Items",
    name_cn: "通用魔法物品",
    name_fr: "Objets Magiques Communs",
  },
  weapon: {
    name_de: "Magische Waffen",
    name_en: "Magic Weapons",
    name_cn: "魔法武器",
    name_fr: "Armes Magiques",
  },
  armor: {
    name_de: "Magische Rüstungen",
    name_en: "Magic Armour",
    name_cn: "魔法护甲",
    name_fr: "Armures Magiques",
  },
  "armor-mages": {
    name_de: "Magische Rüstungen",
    name_en: "Magic Armour",
    name_cn: "魔法护甲",
    name_fr: "Armures Magiques",
  },
  talisman: {
    name_de: "Talismane",
    name_en: "Talismans",
    name_cn: "魔法护符",
    name_fr: "Talismans",
  },
  banner: {
    name_de: "Magische Standarten",
    name_en: "Magic Standards",
    name_cn: "魔法战旗",
    name_fr: "Bannières Magiques",
  },
  artifact: {
    // deprecated
    name_de: "Arkane Artifakte",
    name_en: "Arcane Items",
    name_cn: "奥术物品",
    name_fr: "Objets Cabalistiques",
  },
  "arcane-item": {
    name_de: "Arkane Artifakte",
    name_en: "Arcane Items",
    name_cn: "奥术物品",
    name_fr: "Objets Cabalistiques",
  },
  "enchanted-item": {
    name_de: "Verzauberte Gegenstände",
    name_en: "Enchanted Items",
    name_cn: "附魔物品",
    name_fr: "Objets Enchantés",
  },
  "weapon-runes": {
    name_de: "Waffenrunen",
    name_en: "Weapon Runes",
    name_cn: "武器符文",
    name_fr: "Runes d’Arme",
  },
  "ranged-weapon-runes": {
    name_de: "Ranged Weapon Runes",
    name_en: "Ranged Weapon Runes",
    name_cn: "远程武器符文",
    name_fr: "Runes d’Arme d’Ingénieur",
  },
  "armor-runes": {
    name_de: "Rüstungsrunen",
    name_en: "Armour Runes",
    name_cn: "护甲符文",
    name_fr: "Runes d’Armure",
  },
  "banner-runes": {
    name_de: "Standartenrunen",
    name_en: "Banner Runes",
    name_cn: "战旗符文",
    name_fr: "Runes de Bannière",
  },
  "talismanic-runes": {
    name_de: "Talismanrunen",
    name_en: "Talismanic Runes",
    name_cn: "护符符文",
    name_fr: "Runes de Talisman",
  },
  "engineering-runes": {
    name_de: "Maschinenrunen",
    name_en: "Engineering Runes",
    name_cn: "工程符文",
    name_fr: "Runes d’Ingénierie",
  },
  "runic-tattoos": {
    name_de: "Runic Tattoos",
    name_en: "Runic Tattoos",
    name_cn: "符文纹身",
    name_fr: "Tatouages Runiques",
  },
  triptych: {
    name_de: "Triptych",
    name_en: "Triptych",
    name_cn: "圣龛",
    name_fr: "Triptyque",
  },
  triptychs: {
    name_de: "Triptychs",
    name_en: "Triptychs",
    name_cn: "圣龛",
    name_fr: "Triptyques",
  },
  "kingdom-of-bretonnia": {
    name_de: "Kingdom of Bretonnia",
    name_en: "Kingdom of Bretonnia",
    name_cn: "巴托尼亚王国",
    name_fr: "Royaume de Bretonnie",
  },
  "chaos-mutations": {
    name_de: "Chaos Mutations",
    name_en: "Chaos Mutations",
    name_cn: "混沌变异",
    name_fr: "Mutations du Chaos",
  },
  "chaos-mutation": {
    name_de: "Chaos Mutation",
    name_en: "Chaos Mutation",
    name_cn: "混沌变异",
    name_fr: "Mutation du Chaos",
  },
  "chaos-mutation-character": {
    name_de: "Chaos Mutation",
    name_en: "Chaos Mutation",
    name_cn: "混沌变异",
    name_fr: "Mutation du Chaos",
  },
  "chaos-mutation-chieftain": {
    name_de: "Chaos Mutation",
    name_en: "Chaos Mutation",
    name_cn: "混沌变异",
    name_fr: "Mutation du Chaos",
  },
  "gifts-of-chaos": {
    name_de: "Gifts of Chaos",
    name_en: "Gifts of Chaos",
    name_cn: "混沌赠礼",
    name_fr: "Dons du Chaos",
  },
  "gift-of-chaos": {
    name_de: "Gift of Chaos",
    name_en: "Gift of Chaos",
    name_cn: "混沌赠礼",
    name_fr: "Don du Chaos",
  },
  "chaotic-traits": {
    name_de: "Chaotic Traits",
    name_en: "Chaotic Traits",
    name_cn: "混沌特质",
    name_fr: "Traits Chaotiques",
  },
  "chaotic-trait": {
    name_de: "Chaotic Trait",
    name_en: "Chaotic Trait",
    name_cn: "混沌特质",
    name_fr: "Trait Chaotique",
  },
  "forest-spites": {
    name_de: "Forest Spites",
    name_en: "Forest Spites",
    name_cn: "森林精魂",
    name_fr: "Fiel-follets des Forêts",
  },
  "forest-spite": {
    name_de: "Forest Spite",
    name_en: "Forest Spite",
    name_cn: "森林精魂",
    name_fr: "Fiel-follet des Forêts",
  },
  "beastmen-brayherds": {
    name_de: "Beastmen Brayherds",
    name_en: "Beastmen Brayherds",
    name_cn: "野兽人嘶叫兽群",
    name_fr: "Braillehardes Homme-bêtes",
  },
  "orc-and-goblin-tribes": {
    name_de: "Orc & Goblin Tribes",
    name_en: "Orc & Goblin Tribes",
    name_cn: "兽人&地精部落",
    name_fr: "Tribus des Orques & Gobelins",
  },
  "dwarfen-mountain-holds": {
    name_de: "Dwarfen Mountain Holds",
    name_en: "Dwarfen Mountain Holds",
    name_cn: "矮人群山王国",
    name_fr: "Forteresses Naines",
  },
  "expeditionary-force": {
    name_de: "Expeditionary Force",
    name_en: "Expeditionary Force",
    name_cn: "远征军",
    name_fr: "Corps Expéditionnaire",
  },
  "royal-clan": {
    name_de: "Royal Clan",
    name_en: "Royal Clan",
    name_cn: "皇家氏族",
    name_fr: "Clan Royal",
  },
  "empire-of-man": {
    name_de: "Empire of Man",
    name_en: "Empire of Man",
    name_cn: "人类帝国",
    name_fr: "Empire de l’Homme",
  },
  "wood-elf-realms": {
    name_de: "Wood Elf Realms",
    name_en: "Wood Elf Realms",
    name_cn: "木精灵王国",
    name_fr: "Royaumes Elfes Sylvains",
  },
  "high-elf-realms": {
    name_de: "High Elf Realms",
    name_en: "High Elf Realms",
    name_cn: "高等精灵王国",
    name_fr: "Royaumes Hauts Elfes",
  },
  "tomb-kings-of-khemri": {
    name_de: "Tomb Kings of Khemri",
    name_en: "Tomb Kings of Khemri",
    name_cn: "喀穆里古墓王",
    name_fr: "Rois des Tombes de Khemri",
  },
  "warriors-of-chaos": {
    name_de: "Warriors of Chaos",
    name_en: "Warriors of Chaos",
    name_cn: "混沌勇士",
    name_fr: "Guerriers du Chaos",
  },
  "knightly-virtues": {
    name_de: "Knightly Virtues",
    name_en: "Knightly Virtues",
    name_cn: "骑士美德",
    name_fr: "Vertus Chevaleresques",
  },
  "knightly-virtue": {
    name_de: "Knightly Virtue",
    name_en: "Knightly Virtue",
    name_cn: "骑士美德",
    name_fr: "Vertu Chevaleresque",
  },
  "elven-honours": {
    name_de: "Elven Honours",
    name_en: "Elven Honours",
    name_es: "Honores Élficos",
    name_cn: "精灵荣耀",
    name_fr: "Honneurs Elfiques",
  },
  "elven-honour": {
    name_de: "Elven Honour",
    name_en: "Elven Honour",
    name_es: "Honor Élfico",
    name_cn: "精灵荣耀",
    name_fr: "Honneur Elfique",
  },
  none: {
    name_de: "Keine",
    name_en: "None",
    name_cn: "无",
    name_fr: "Aucun",
  },
  daemonology: {
    name_de: "Dämonologie",
    name_en: "Daemonology",
    name_cn: "恶魔法系",
    name_fr: "Démonisme",
  },
  "dark-magic": {
    name_de: "Schwarze Magie",
    name_en: "Dark Magic",
    name_cn: "黑暗魔法",
    name_fr: "Magie Noire",
  },
  elementalism: {
    name_de: "Elementarismus",
    name_en: "Elementalism",
    name_cn: "元素法系",
    name_fr: "Élémentalisme",
  },
  "battle-magic": {
    name_de: "Kampfmagie",
    name_en: "Battle Magic",
    name_cn: "战斗魔法",
    name_fr: "Magie de Bataille",
  },
  "high-magic": {
    name_de: "Weiße Magie",
    name_en: "High Magic",
    name_cn: "高等法术",
    name_fr: "Haute Magie",
  },
  illusion: {
    name_de: "Illusion",
    name_en: "Illusion",
    name_cn: "幻术法系",
    name_fr: "Illusionnisme",
  },
  necromancy: {
    name_de: "Nekromantie",
    name_en: "Necromancy",
    name_cn: "死灵法系",
    name_fr: "Nécromancie",
  },
  "waaagh-magic": {
    name_de: "Waaagh! Magie",
    name_en: "Waaagh! Magic",
    name_cn: "Waaagh!魔法",
    name_fr: "Magie Waaagh!",
  },
  "troll-magic": {
    name_de: "Troll Magie",
    name_en: "Troll Magic",
    name_cn: "巨魔法系",
    name_fr: "Magie Troll",
  },
  shadowlands: {
    name_de: "Shadowlands",
    name_en: "Shadowlands",
    name_cn: "阴影之地法系",
    name_fr: "Terres des Ombres",
  },
  "errantry-crusades": {
    name_de: "Errantry Crusades",
    name_en: "Errantry Crusades",
    name_cn: "侠义远征军",
    name_fr: "Croisades d’Errance",
  },
  "bretonnian-exiles": {
    name_de: "Bretonnian Exiles",
    name_en: "Bretonnian Exiles",
    name_cn: "巴托尼亚放逐者",
    name_fr: "Exilés Bretonniens",
  },
  "nehekharan-royal-hosts": {
    name_de: "Nehekharan Royal Hosts",
    name_en: "Nehekharan Royal Hosts",
    name_cn: "尼赫喀拉皇家大军",
    name_fr: "Osts Royaux de Nehekhara",
  },
  "mortuary-cults": {
    name_de: "Mortuary Cults",
    name_en: "Mortuary Cults",
    name_cn: "葬仪教团",
    name_fr: "Cultes Mortuaires",
  },
  "nomadic-waaagh": {
    name_de: "Nomadic Waaagh!",
    name_en: "Nomadic Waaagh!",
    name_cn: "游牧Waaagh!",
    name_fr: "Waaagh! Nomade",
  },
  "troll-horde": {
    name_de: "Troll Horde",
    name_en: "Troll Horde",
    name_cn: "巨魔大军",
    name_fr: "Horde de Trolls",
  },
  "wolves-of-the-sea": {
    name_de: "Wolves of the Sea",
    name_en: "Wolves of the Sea",
    name_cn: "狩海群狼",
    name_fr: "Loups des Mers",
  },
  "heralds-of-darkness": {
    name_de: "Heralds of Darkness",
    name_en: "Heralds of Darkness",
    name_cn: "黑暗先驱",
    name_fr: "Hérauts des Ténèbres",
  },
  "chaos-dwarfs": {
    name_de: "Chaos Dwarfs",
    name_en: "Chaos Dwarfs",
    name_cn: "混沌矮人",
    name_fr: "Nains du Chaos",
  },
  "cd-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "vampire-counts": {
    name_de: "Vampirfürsten",
    name_en: "Vampire Counts",
    name_cn: "吸血鬼公爵",
    name_fr: "Comtes Vampires",
  },
  "vc-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "vampiric-powers": {
    name_de: "Vampirkräfte",
    name_en: "Vampiric Powers",
    name_cn: "吸血鬼之力",
    name_fr: "Pouvoirs Vampiriques",
  },
  "vampiric-power": {
    name_de: "Vampirkraft",
    name_en: "Vampiric Power",
    name_cn: "吸血鬼之力",
    name_fr: "Pouvoir Vampirique",
  },
  "dark-elves": {
    name_de: "Dark Elves",
    name_en: "Dark Elves",
    name_cn: "黑暗精灵",
    name_fr: "Elfes Noirs",
  },
  "de-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  skaven: {
    name_de: "Skaven",
    name_en: "Skaven",
    name_cn: "斯卡文鼠人",
    name_fr: "Skavens",
  },
  "sk-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "daemons-of-chaos": {
    name_de: "Daemons of Chaos",
    name_en: "Daemons of Chaos",
    name_cn: "混沌恶魔",
    name_fr: "Démons du Chaos",
  },
  "doc-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "daemonic-gifts-common": {
    name_de: "Chaotic Gifts",
    name_en: "Chaotic Gifts",
    name_cn: "混沌赠礼",
    name_fr: "Dons du Chaos",
  },
  "daemonic-gift-common": {
    name_de: "Chaotic Gift",
    name_en: "Chaotic Gift",
    name_cn: "混沌赠礼",
    name_fr: "Don du Chaos",
  },
  "daemonic-icons-common": {
    name_de: "Chaotic Icons",
    name_en: "Chaotic Icons",
    name_cn: "混沌圣像",
    name_fr: "Icônes du Chaos",
  },
  "daemonic-icon-common": {
    name_de: "Chaotic Icon",
    name_en: "Chaotic Icon",
    name_cn: "混沌圣像",
    name_fr: "Icône du Chaos",
  },
  "daemonic-gifts-khorne": {
    name_de: "Gifts of Khorne",
    name_en: "Gifts of Khorne",
    name_cn: "Gifts of Khorne",
    name_fr: "Dons de Khorne",
  },
  "daemonic-gift-khorne": {
    name_de: "Gift of Khorne",
    name_en: "Gift of Khorne",
    name_cn: "恐虐赠礼",
    name_fr: "Don de Khorne",
  },
  "daemonic-icons-khorne": {
    name_de: "Icons of Khorne",
    name_en: "Icons of Khorne",
    name_cn: "恐虐圣像",
    name_fr: "Icônes de Khorne",
  },
  "daemonic-icon-khorne": {
    name_de: "Icon of Khorne",
    name_en: "Icon of Khorne",
    name_cn: "恐虐圣像",
    name_fr: "Icône de Khorne",
  },
  "daemonic-gifts-nurgle": {
    name_de: "Gifts of Nurgle",
    name_en: "Gifts of Nurgle",
    name_cn: "纳垢赠礼",
    name_fr: "Dons de Nurgle",
  },
  "daemonic-gift-nurgle": {
    name_de: "Gift of Nurgle",
    name_en: "Gift of Nurgle",
    name_cn: "纳垢赠礼",
    name_fr: "Don de Nurgle",
  },
  "daemonic-icons-nurgle": {
    name_de: "Icons of Nurgle",
    name_en: "Icons of Nurgle",
    name_cn: "纳垢圣像",
    name_fr: "Icônes de Nurgle",
  },
  "daemonic-icon-nurgle": {
    name_de: "Icon of Nurgle",
    name_en: "Icon of Nurgle",
    name_cn: "纳垢圣像",
    name_fr: "Icône de Nurgle",
  },
  "daemonic-gifts-slaanesh": {
    name_de: "Gifts of Slaanesh",
    name_en: "Gifts of Slaanesh",
    name_cn: "色孽赠礼",
    name_fr: "Dons de Slaanesh",
  },
  "daemonic-gift-slaanesh": {
    name_de: "Gift of Slaanesh",
    name_en: "Gift of Slaanesh",
    name_cn: "色孽赠礼",
    name_fr: "Don de Slaanesh",
  },
  "daemonic-icons-slaanesh": {
    name_de: "Icons of Slaanesh",
    name_en: "Icons of Slaanesh",
    name_cn: "色孽圣像",
    name_fr: "Icônes de Slaanesh",
  },
  "daemonic-icon-slaanesh": {
    name_de: "Icon of Slaanesh",
    name_en: "Icon of Slaanesh",
    name_cn: "色孽圣像",
    name_fr: "Icône de Slaanesh",
  },
  "daemonic-gifts-tzeentch": {
    name_de: "Gifts of Tzeentch",
    name_en: "Gifts of Tzeentch",
    name_cn: "奸奇赠礼",
    name_fr: "Dons de Tzeentch",
  },
  "daemonic-gift-tzeentch": {
    name_de: "Gift of Tzeentch",
    name_en: "Gift of Tzeentch",
    name_cn: "奸奇赠礼",
    name_fr: "Don de Tzeentch",
  },
  "daemonic-icons-tzeentch": {
    name_de: "Icons of Tzeentch",
    name_en: "Icons of Tzeentch",
    name_cn: "奸奇圣像",
    name_fr: "Icônes de Tzeentch",
  },
  "daemonic-icon-tzeentch": {
    name_de: "Icon of Tzeentch",
    name_en: "Icon of Tzeentch",
    name_cn: "奸奇圣像",
    name_fr: "Icône de Tzeentch",
  },
  "forbidden-poisons": {
    name_de: "Forbidden Poisons",
    name_en: "Forbidden Poisons",
    name_cn: "禁忌剧毒",
    name_fr: "Poisons Interdits",
  },
  "gifts-of-khaine": {
    name_de: "Gifts of Khaine",
    name_en: "Gifts of Khaine",
    name_cn: "凯恩赠礼",
    name_fr: "Dons de Khaine",
  },
  "forbidden-poison": {
    name_de: "Forbidden Poison",
    name_en: "Forbidden Poison",
    name_cn: "禁忌剧毒",
    name_fr: "Poison Interdit",
  },
  "gift-of-khaine": {
    name_de: "Gift of Khaine",
    name_en: "Gift of Khaine",
    name_cn: "凯恩赠礼",
    name_fr: "Don de Khaine",
  },
  "ogre-kingdoms": {
    name_de: "Ogre Kingdoms",
    name_en: "Ogre Kingdoms",
    name_cn: "食人魔王国",
    name_fr: "Royaumes Ogres",
  },
  "ok-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "big-names": {
    name_de: "Big Names",
    name_en: "Big Names",
    name_cn: "威名",
    name_fr: "Grands Noms",
  },
  "big-name": {
    name_de: "Big Name",
    name_en: "Big Name",
    name_cn: "威名",
    name_fr: "Grand Nom",
  },
  "disciplines-old-ones": {
    name_de: "Disciplines of the Old Ones",
    name_en: "Disciplines of the Old Ones",
    name_cn: "上古戒律",
    name_fr: "Disciplines des Anciens",
  },
  "discipline-old-ones": {
    name_de: "Discipline of the Old Ones",
    name_en: "Discipline of the Old Ones",
    name_cn: "上古戒律",
    name_fr: "Discipline des Anciens",
  },
  lizardmen: {
    name_de: "Lizardmen",
    name_en: "Lizardmen",
    name_cn: "蜥蜴人",
    name_fr: "Hommes-Lézards",
  },
  "lm-renegade": {
    name_de: "Renegade",
    name_en: "Renegade",
    name_cn: "Renegade",
    name_fr: "Renegade",
  },
  "city-state-of-nuln": {
    name_de: "City-State of Nuln",
    name_en: "City-State of Nuln",
    name_cn: "努恩城卫",
    name_fr: "Cité-État de Nuln",
  },
  "knightly-order-panther": {
    name_de: "Order of the Knights Panther",
    name_en: "Order of the Knights Panther",
    name_cn: "猎豹骑士团",
    name_fr: "Ordre des Chevaliers Panthères",
  },
  "knightly-order-white-wolf": {
    name_de: "Order of the White Wolf",
    name_en: "Order of the White Wolf",
    name_cn: "白狼骑士团",
    name_fr: "Ordre du Loup Blanc",
  },
  "knightly-order-blazing-sun": {
    name_de: "Order of the Blazing Sun",
    name_en: "Order of the Blazing Sun",
    name_cn: "焰阳骑士团",
    name_fr: "Order du Soleil",
  },
  "knightly-order-morr": {
    name_de: "Order of the Knights of Morr",
    name_en: "Order of the Knights of Morr",
    name_cn: "莫尔骑士团",
    name_fr: "Ordre des Chevaliers de Morr",
  },
  "knightly-order-fiery-heart": {
    name_de: "Order of the Fiery Heart",
    name_en: "Order of the Fiery Heart",
    name_cn: "燃烧之心骑士团",
    name_fr: "Ordre du Cœur Ardent",
  },
  "the-chracian-warhost": {
    name_de: "The Chracian Warhost",
    name_en: "The Chracian Warhost",
    name_cn: "查瑞斯战团",
    name_fr: "L’Ost de Chrace",
  },
  "sea-guard-garrison": {
    name_de: "Sea Guard Garrison",
    name_en: "Sea Guard Garrison",
    name_cn: "海卫戍军",
    name_fr: "Garnison de la Garde Maritime",
  },
  "orions-wild-hunt": {
    name_de: "Orion's Wild Hunt",
    name_en: "Orion's Wild Hunt",
    name_cn: "奥莱恩的狂猎",
    name_fr: "Chasse Sauvage d’Orion",
  },
  "host-of-talsyn": {
    name_de: "Host of Talsyn",
    name_en: "Host of Talsyn",
    name_cn: "塔塞恩大军",
    name_fr: "Ost de Talsyn",
  },
  "lore-of-the-wilds": {
    name_de: "Lore of the Wilds",
    name_en: "Lore of the Wilds",
    name_cn: "荒野法系",
    name_fr: "Domaine des Terres Sauvages",
  },
  kindreds: {
    name_de: "Alter/Noble Kindreds",
    name_en: "Alter/Noble Kindreds",
    name_cn: "易形/贵族亲族",
    name_fr: "Clans Changeformes/Nobles",
  },
  kindred: {
    name_de: "Kindred",
    name_en: "Kindred",
    name_cn: "亲族",
    name_fr: "Clan",
  },
  "minotaur-blood-herd": {
    name_de: "Minotaur Blood Herd",
    name_en: "Minotaur Blood Herd",
    name_cn: "牛头人血兽群",
    name_fr: "Harde de Sang Minotaure",
  },
  "wild-herd": {
    name_de: "Wild Herd",
    name_en: "Wild Herd",
    name_cn: "狂野兽群",
    name_fr: "Harde Sauvage",
  },
  "primal-magic": {
    name_de: "Lore of Primal Magic",
    name_en: "Lore of Primal Magic",
    name_cn: "原始法系",
    name_fr: "Domaine de Magie Primordiale",
  },
  "grand-cathay": {
    name_de: "Grand Cathay",
    name_en: "Grand Cathay",
    name_cn: "震旦天朝",
    name_fr: "Grand Cathay",
  },
  "lore-of-yang": {
    name_de: "Lore of Yang",
    name_en: "Lore of Yang",
    name_cn: "阳系法术",
    name_fr: "Domaine de Yang",
  },
  "lore-of-yin": {
    name_de: "Lore of Yin",
    name_en: "Lore of Yin",
    name_cn: "阴系法术",
    name_fr: "Domaine de Yin",
  },
  "jade-fleet": {
    name_de: "Jade Fleet",
    name_en: "Jade Fleet",
    name_cn: "玉舰队",
    name_fr: "Flotte de Jade",
  },
  "renegade-crowns": {
    name_de: "Renegade Crowns",
    name_en: "Renegade Crowns",
    name_cn: "变节王冠",
    name_fr: "Couronnes Renégates",
  },
  "slayer-host": {
    name_de: "Slayer Host",
    name_en: "Slayer Host",
    name_cn: "屠夫军团",
    name_fr: "Ost Tueur",
  },
  "battle-march": {
    name_de: "Battle March",
    name_en: "Battle March",
    name_cn: "战斗行军",
    name_fr: "Colonne de Bataille",
  },
  "incantation-scrolls": {
    name_de: "Incantation Scrolls",
    name_en: "Incantation Scrolls",
    name_cn: "咒语卷轴",
    name_fr: "Parchemins d’Incantation",
  },
  "incantation-scroll": {
    name_de: "Incantation Scroll",
    name_en: "Incantation Scroll",
    name_cn: "咒语卷轴",
    name_fr: "Parchemins d’Incantation",
  },
  "warriors-of-wind-and-field": {
    name_de: "Warriors of Wind & Field",
    name_en: "Warriors of Wind & Field",
    name_cn: "Warriors of Wind & Field",
    name_fr: "Warriors of Wind & Field",
  },
  "hordes-of-chaos": {
    name_de: "Hordes of Chaos",
    name_en: "Hordes of Chaos",
    name_cn: "Hordes of Chaos",
    name_fr: "Hordes of Chaos",
  },
};
